import { render, staticRenderFns } from "./TextToAudio.vue?vue&type=template&id=f5e7ee94&scoped=true"
import script from "./TextToAudio.vue?vue&type=script&lang=js"
export * from "./TextToAudio.vue?vue&type=script&lang=js"
import style0 from "./TextToAudio.vue?vue&type=style&index=0&id=f5e7ee94&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5e7ee94",
  null
  
)

export default component.exports